
import * as React from 'react';
import { Action } from './action';
import { State } from './state';

export type UserContextParams = [ State, React.Dispatch<Action> ];

export const UserContext = React.createContext<UserContextParams|null>(null);
